import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Navbar from '../components/Navbar';

function AdminOrgRequests() {
  const navigate = useNavigate();
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [actionLoading, setActionLoading] = useState(null);

  useEffect(() => {
    fetchRequests();
  }, []);

  const fetchRequests = async () => {
    try {
      const token = localStorage.getItem('accessToken');
      const res = await axios.get('/api/orgs/requests', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setRequests(res.data);
    } catch (err) {
      if (err.response?.status === 403) {
        setError('Platform admin access required.');
      } else {
        setError('Failed to load requests.');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = async (requestId) => {
    if (!window.confirm('Approve this organization? This will create the org and send an activation email.')) return;
    setActionLoading(requestId);
    try {
      const token = localStorage.getItem('accessToken');
      await axios.post(`/api/orgs/requests/${requestId}/approve`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchRequests();
    } catch (err) {
      alert(err.response?.data?.error || 'Failed to approve.');
    } finally {
      setActionLoading(null);
    }
  };

  const handleReject = async (requestId) => {
    const reason = window.prompt('Rejection reason (optional):');
    if (reason === null) return; // cancelled
    setActionLoading(requestId);
    try {
      const token = localStorage.getItem('accessToken');
      await axios.post(`/api/orgs/requests/${requestId}/reject`, { reason }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchRequests();
    } catch (err) {
      alert(err.response?.data?.error || 'Failed to reject.');
    } finally {
      setActionLoading(null);
    }
  };

  return (
    <div>
      <Navbar />
      <div className="container">
        <div className="card">
          <h2>🏢 Organization Signup Requests</h2>
          <p style={{ color: '#666', marginBottom: '20px' }}>Review and approve organization registrations.</p>
        </div>

        {loading && <div className="card"><p>Loading...</p></div>}
        {error && <div className="card"><p style={{ color: '#dc2626' }}>{error}</p></div>}

        {!loading && requests.length === 0 && (
          <div className="card"><p style={{ color: '#666' }}>No pending requests.</p></div>
        )}

        {requests.map(req => (
          <div key={req.request_id} className="card" style={{ borderLeft: `4px solid ${req.status === 'pending' ? '#f59e0b' : req.status === 'approved' ? '#10b981' : '#ef4444'}` }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div>
                <h3 style={{ margin: '0 0 4px' }}>{req.org_name}</h3>
                <p style={{ margin: '0 0 4px', fontSize: '14px', color: '#555' }}>
                  {req.requester_name} — <strong>{req.requester_email}</strong>
                </p>
                <p style={{ margin: '0 0 4px', fontSize: '13px', color: '#888' }}>
                  Domain: <code>{req.domain}</code>
                  {req.industry && ` · Industry: ${req.industry}`}
                </p>
                <p style={{ margin: '0', fontSize: '12px', color: '#aaa' }}>
                  Submitted: {new Date(req.created_at).toLocaleString()}
                  {req.reviewed_at && ` · Reviewed: ${new Date(req.reviewed_at).toLocaleString()}`}
                </p>
                {req.rejection_reason && (
                  <p style={{ margin: '8px 0 0', fontSize: '13px', color: '#dc2626' }}>
                    Rejection reason: {req.rejection_reason}
                  </p>
                )}
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', flexShrink: 0 }}>
                <span style={{
                  padding: '4px 12px', borderRadius: '12px', fontSize: '12px', fontWeight: '600',
                  backgroundColor: req.status === 'pending' ? '#fef3c7' : req.status === 'approved' ? '#d1fae5' : '#fee2e2',
                  color: req.status === 'pending' ? '#92400e' : req.status === 'approved' ? '#065f46' : '#991b1b'
                }}>
                  {req.status}
                </span>
              </div>
            </div>

            {req.status === 'pending' && (
              <div style={{ display: 'flex', gap: '12px', marginTop: '16px', paddingTop: '12px', borderTop: '1px solid #f3f4f6' }}>
                <button
                  onClick={() => handleApprove(req.request_id)}
                  disabled={actionLoading === req.request_id}
                  style={{ padding: '8px 20px', backgroundColor: '#10b981', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}
                >
                  {actionLoading === req.request_id ? '...' : '✓ Approve'}
                </button>
                <button
                  onClick={() => handleReject(req.request_id)}
                  disabled={actionLoading === req.request_id}
                  style={{ padding: '8px 20px', backgroundColor: '#fff', color: '#dc2626', border: '1px solid #fecaca', borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}
                >
                  ✗ Reject
                </button>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default AdminOrgRequests;
